module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-206.cc5fb60f.jpg";